import { withSvgIcon } from './withSvgIcon';

export const USDTLogo = withSvgIcon(
  <>
    <circle cx="10" cy="10" r="10" fill="#009393" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.76683 5H14.4067C14.6128 5 14.8033 5.11028 14.9061 5.2892L17.4232 9.66962C17.5537 9.89679 17.515 10.1835 17.3288 10.3677L10.4003 17.2226C10.1758 17.4446 9.8148 17.4446 9.59036 17.2226L2.67122 10.377C2.4807 10.1885 2.44502 9.89341 2.58512 9.66482L5.27575 5.27515C5.38054 5.10419 5.56649 5 5.76683 5ZM13.2911 6.95571V8.1848H10.83V9.03695C12.5585 9.12802 13.8554 9.50203 13.865 9.95033L13.8649 10.8849C13.8553 11.3332 12.5585 11.7072 10.83 11.7983V13.8896H9.19573V11.7983C7.46717 11.7072 6.17031 11.3332 6.16071 10.8849L6.16075 9.95033C6.17038 9.50203 7.46717 9.12802 9.19573 9.03695V8.1848H6.73458V6.95571H13.2911ZM10.0129 11.1562C11.8575 11.1562 13.3993 10.84 13.7767 10.4176C13.4567 10.0595 12.2993 9.7776 10.83 9.70018V10.5924C10.5666 10.6063 10.2932 10.6136 10.0129 10.6136C9.73246 10.6136 9.4591 10.6063 9.19573 10.5924V9.70018C7.72639 9.7776 6.569 10.0595 6.24903 10.4176C6.62635 10.84 8.16818 11.1562 10.0129 11.1562Z"
      fill="white"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
